import Navbar from "./Components/Navbar";
import Body from "./Components/Body";
import Achievements from "./Components/Achievements"
import Skills from "./Components/Skills";
import Contact from "./Components/Contact";
import HorizontalLine from "./Components/HorizontalLine";
function App() {
  return (
    <div>
      <Navbar />
      <Body />
      <Achievements />
      <Skills />
      <div className="w-6/12 mx-60">
        <HorizontalLine />
      </div>
      <Contact />
    </div>
  )
}
export default App;
